<template>
  <div class="widget white_box urgent_actions">
    <div class="widget_header">
      <h3 class="heading">
        Completed SEO Actions
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/actions/completed"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove()"
        >
          Delete
        </button>
      </div>
    </div>

    <div
      v-if="!loading && actions.length > 0"
      class="action_items"
    >
      <div
        v-for="(action, index) in limitedActions"
        :key="index"
        :title="action.completed_action_title ?? action.action_title"
        class="action_item tooltipster"
      >
        <div class="completed_icon" />
        <div class="action_title">
          {{ action.completed_action_title ?? action.action_title }}
        </div>
        <div class="action_type_wrap">
          <span :class="`action_type ${getActionTypeClass(action.action_type)}`">{{ action.action_type }}</span>
        </div>
        <div
          v-if="activeWebsite.show_action_timings !== '0'"
          class="time"
        >
          <i class="icon clock_item" />
          <span class="p_small">{{ action.action_time }} mins</span>
        </div>
      </div>
    </div>

    <div
      v-else
      class="loading_widget_data"
    >
      <div v-if="loading">
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>
      <div v-else>
        No actions completed
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      actions: [],
      limit: 4,
      loading: true
    }
  },
  computed: {
    ...mapState('dashboard', ['uuid', 'preview', 'activeWebsite']),
    limitedActions() {
      if (this.actions) {
        return this.actions.slice(0, this.limit);
      }
      return this.actions;
    }
  },
  mounted() {
    axios.post('/ajax/dashboard/get-widget-data', {
      type: 'topCompletedActions',
      uuid: this.uuid
    }).then(response => {
      this.actions = response.data;
      this.loading = false;
    }).catch(error => {
      console.log(error);
    });
  },
  methods: {
    getActionTypeClass(type) {
      return type.replace(' ', '').toLowerCase();
    }
  }
}
</script>

<style scoped>
.urgent_actions {
  width: 100%;
  max-width: none;
  display: flex;
  flex-direction: column;
}

.action_items {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
}

.action_title {
  font-size: 0.875rem;
  line-height: 1.72;
  letter-spacing: -0.00715em;
  color: #4E4E54;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  width: 70%;
}

.action_item {
  padding: 1.5rem;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: space-between;
  display: flex;
  border: 1px solid #E8E5E2;
  border-radius: 0.75rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  background-color: white;
}

.completed_icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #37B2A8;
  background-color: #37B2A8;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='7' viewBox='0 0 10 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.375 0.75L3.73438 5.8125L1.625 3.51136' stroke='%23F7F7FC' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: center;
}

.action_type_wrap {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action_type {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  line-height: 13px;
  letter-spacing: -0.1px;
  background-color: #F0E9FF;
  color: #5A3CD7;
}

.action_type.onsite {
  background-color: #FDF7DB;
  color: #EAB64D;
}

.action_type.localseo {
  background-color: #E4FAFD;
  color: #1993AE;
}

.time {
  width: 10%;
}
</style>
